import CompanyLicenses from 'app-support/company/components/Licenses/components/CompanyLicenses'
import ShopLicenses from 'app-support/company/components/Licenses/components/ShopLicenses'

const Licenses = () => {
  return (
    <>
      <CompanyLicenses />
      <ShopLicenses />
    </>
  )
}

export default Licenses
